import type { FC } from "react";

import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import type { Risk } from "@/utils/patient";

type RiskModalFooterProps = {
  setRiskModalOpen: React.Dispatch<React.SetStateAction<Risk | "none">>;
  handleSubmit: () => Promise<void>;
};

const RiskModalFooter: FC<RiskModalFooterProps> = ({
  setRiskModalOpen,
  handleSubmit,
}) => {
  return (
    <DialogFooter className="flex gap-3 px-6">
      <Button
        type="button"
        className="w-full"
        onClick={() => {
          setRiskModalOpen("none");
        }}
        variant={"outline"}
      >
        Annuler
      </Button>
      <Button
        type="submit"
        className="w-full"
        variant={"blue"}
        onClick={() => {
          handleSubmit();
        }}
      >
        Générer
      </Button>
    </DialogFooter>
  );
};

export default RiskModalFooter;
